import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import { VoucherToggle } from '~/services/PromoService';

type Props = {
  toggles: Array<VoucherToggle>;
  onToggleClick?: (toggle: VoucherToggle) => void;
  selectedToggle?: VoucherToggle;
};

export default function VoucherToggleStack({ toggles, onToggleClick, selectedToggle }: Props) {
  if (toggles.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Stack direction="row" flexWrap="wrap" useFlexGap spacing={0.5} sx={{ py: 0.5 }}>
      {toggles.map((toggle) => (
        <Chip
          key={toggle}
          label={toggle}
          size="small"
          color={selectedToggle === toggle ? 'primary' : 'default'}
          variant={selectedToggle === toggle ? 'filled' : 'outlined'}
          clickable={Boolean(onToggleClick)}
          onClick={onToggleClick ? () => onToggleClick(toggle) : undefined}
        />
      ))}
    </Stack>
  );
}
